export default __webpack_public_path__ + "fonts/bariol_light-webfont.eot";